import { Box, Flex, Text, useToast } from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import {
  useGetScopeThreeConversionFactors
} from "../../../../hooks/query/conversion-factors";
import { showErrorToast } from "../../../../utils";
import { CategorySelector, ScopeThreeFactorsGrid } from "./index";

function ScopeThreeFactorsTab({ selectedYear, organizationStructure }) {
  const { t: globalTranslation } = useTranslation("translation");
  const toast = useToast();

  const [selectedCategory, setSelectedCategory] = useState("categoryOne");

  const {
    data: scopeThreeFactorsData
  } = useGetScopeThreeConversionFactors({
    year: selectedYear
  }, {
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  return (
    <Box>
      <Flex my={4}>
        <CategorySelector
          selectedCategory={selectedCategory}
          handleCategorySelection={(value) => setSelectedCategory(value)}
        />
      </Flex>
      {!scopeThreeFactorsData || Object.keys(scopeThreeFactorsData)?.length === 0 ?
        <Text fontSize="lg" fontWeight="bold">
          {globalTranslation("noDataAvailable")}
        </Text> :
        <ScopeThreeFactorsGrid data={scopeThreeFactorsData} selectedCategory={selectedCategory} organizationStructure={organizationStructure} />
      }
    </Box>
  );
}

export default ScopeThreeFactorsTab;